import { render, staticRenderFns } from "./LutonCity.vue?vue&type=template&id=5ae37c11&scoped=true&"
import script from "./LutonCity.vue?vue&type=script&lang=js&"
export * from "./LutonCity.vue?vue&type=script&lang=js&"
import style0 from "./LutonCity.vue?vue&type=style&index=0&id=5ae37c11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae37c11",
  null
  
)

export default component.exports